document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn   = document.getElementById('features-search-toggle');
  const searchWrap  = document.getElementById('features-search-wrap');
  const searchInner = document.getElementById('features-search-inner');
  const searchInput = document.getElementById('features-search');
  const clearBtn    = document.getElementById('features-search-clear');
  const countEl     = document.getElementById('features-count');
  const noResults   = document.getElementById('features-no-results');
  const bubbles     = Array.from(document.querySelectorAll('.vehicle-feature-bubble'));

  if (!toggleBtn || !searchInput || !bubbles.length) return;

  const total = bubbles.length;

  const filter = () => {
    const q = searchInput.value.trim().toLowerCase();
    let visible = 0;
    bubbles.forEach(b => {
      const match = !q || b.dataset.name.includes(q);
      b.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    clearBtn.style.display = q ? '' : 'none';
    noResults.classList.toggle('hidden', visible > 0);
    countEl.textContent = q ? visible + ' / ' + total : '';
    searchInner.style.borderColor = q && visible === 0 ? '#fca5a5' : '#0047ab';
  };

  toggleBtn.addEventListener('click', () => {
    const isOpen = searchWrap.style.display !== 'none';
    searchWrap.style.display = isOpen ? 'none' : '';
    toggleBtn.style.display  = isOpen ? '' : 'none';
    if (!isOpen) searchInput.focus();
    if (isOpen) { searchInput.value = ''; filter(); }
  });

  searchInput.addEventListener('focus', () => {
    searchInner.style.borderColor = '#0047ab';
    searchInner.style.boxShadow   = '0 0 0 3px rgba(0,71,171,.1)';
  });
  searchInput.addEventListener('blur', () => {
    searchInner.style.borderColor = '';
    searchInner.style.boxShadow   = '';
  });
  searchInput.addEventListener('input', filter);
  clearBtn.addEventListener('click', () => { searchInput.value = ''; filter(); searchInput.focus(); });
});
